import React, { Component } from 'react';
import {
  Grid,
  Icon,
  Header,
  Button,
  Table,
  Modal,
  Image,
  Divider,
  Dropdown,
  Label,
  Form
} from 'semantic-ui-react';
import '../customerinfo/custinfo.css';
import { gendropdown } from '../../services/gendropdown';
class SalaryCodes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listitems: [],
      locationlist: [],
      editvalue: {},
      deletevalue: [],
      deletelist: [],
      editinfo: {},
      newcode: false,
      disciplinefilter: '',
      locationfilter: ''
    };
  }
  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.locations &&
      this.props.locations.length &&
      !this.state.locationlist.length
    ) {
      this.genlocations();
    }
  }
  componentDidMount() {
    if (
      this.props.locations &&
      this.props.locations.length &&
      !this.state.locationlist.length
    ) {
      this.genlocations();
    }
  }
  gendisciplineoptions(salarycodes) {
    if (salarycodes) {
      let options = [
        {
          key: 0,
          text: '...',
          value: ''
        }
      ];
      let newoptions = gendropdown(
        'id',
        'description',
        'description',
        salarycodes
      );
      newoptions.map(newopt => {
        if (options.findIndex(opt => opt.value === newopt.value) === -1) {
          options = options.concat(newopt);
        }
      });
      return options;
    }
  }
  genlocationsearchoptions(codes) {
    if (this.props.locations && this.props.codes) {
      let options = [
        {
          key: 0,
          text: '...',
          value: ''
        }
      ];
      //      export const gendropdown = (key, text, value, array) => {
      let newoptions = gendropdown(
        'code',
        'description',
        'description',
        this.props.locations
      );
      newoptions = newoptions.filter(
        opt => codes.findIndex(code => code.location === opt.value) > -1
      );
      console.log('location options', newoptions);
      options = options.concat(newoptions);
      return options;
    }
  }
  genlocations() {
    let lst = this.state.locationlist;
    this.props.locations.map(item => {
      let itemtext = item.description;
      let newitem = {
        key: item.code,
        value: item.description,
        text: itemtext
      };
      lst = lst.concat(newitem);
    });
    this.setState({ locationlist: lst });
  }
  handlesave() {
    if (this.state.newcode) {
      let newcode = Object.assign({}, this.state.editvalue);
      newcode.code = this.props.codes.length + 2;
      this.props.addcode(newcode);
      this.setState({ newcode: false, editvalue: {}, showModal: false });
    } else {
      this.props
        .updatecode(this.state.editvalue)
        .then(() => this.setState({ editvalue: {}, showModal: false }));
    }
  }
  handledelete() {
    var deletepayload = [];
    this.state.deletevalue.map(dl => this.props.handleDelete(dl.code));
  }
  gensalarymodal(sal) {
    var formtitle = 'Edit:';
    if (this.state.newcode) {
      formtitle = 'Add Contact';
    }
    var locationvalue;
    if (this.state.locationlist) {
      locationvalue = this.state.locationlist.find(
        location => location.description === this.state.editvalue.location
      );
    }
    console.log(this.state.editvalue);
    return (
      <Modal
        open={this.state.showModal}
        onClose={() => this.setState({ showModal: false })}
      >
        <Modal.Header>Edit: {sal.description}</Modal.Header>
        <Modal.Content image>
          <Image
            wrapped
            size="medium"
            src={require('../shared-components/edf_logo.bmp')}
          />
          <Form>
            <Grid>
              <Grid.Column width={2} textAlign="center" />
              <Grid.Column width={10}>
                <Form.Group>
                  <Form.Field>
                    <Dropdown
                      value={this.state.editvalue.location}
                      selection
                      search
                      options={this.state.locationlist}
                      onChange={(e, { value }) => {
                        sal.location = value;
                        this.setState({ editvalue: sal });
                      }}
                    />
                  </Form.Field>
                </Form.Group>
                <Form.Group>
                  <Form.Input
                    label="Discipline"
                    value={sal.description}
                    onChange={e => {
                      sal.description = e.target.value;
                      this.setState({ editvalue: sal });
                    }}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Input
                    label="Pay Rate"
                    icon="dollar"
                    iconPosition="left"
                    type="number"
                    value={sal.payrate}
                    onChange={e => {
                      sal.payrate = e.target.value;
                      this.setState({ editvalue: sal });
                    }}
                  />
                </Form.Group>
              </Grid.Column>
            </Grid>
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button
            id="billingsavebtn"
            color="green"
            icon
            onClick={() => {
              this.handlesave();
            }}
          >
            <Icon name="check" />
            {this.state.newcode ? 'Create Code' : 'Save'}
          </Button>
          <Button
            id="billingsavebtn"
            color="red"
            icon
            disabled={this.state.newcode}
            onClick={() => {
              this.handlesave();
            }}
          >
            <Icon name="cancel" />
            Delete
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
  gensalarys() {
    if (this.props.codes) {
      let codes = this.props.codes;
      if (this.state.disciplinefilter.length) {
        console.log(this.state.disciplinefilter);
        codes = codes.filter(
          code => code.description === this.state.disciplinefilter
        );
      }
      if (this.state.locationfilter.length) {
        codes = codes.filter(
          code => code.location === this.state.locationfilter
        );
      }
      return codes;
    } else return [];
  }
  genresults(codes) {
    if (codes) {
      return codes.map(code => {
        return (
          <Table.Row
            onClick={() =>
              this.setState({
                editvalue: code,
                showModal: true,
                newcode: false
              })
            }
          >
            <Table.Cell>{code.description}</Table.Cell>
            <Table.Cell>{code.location}</Table.Cell>
            <Table.Cell>{'$' + code.payrate}</Table.Cell>
          </Table.Row>
        );
      });
    }
  }
  render() {
    let salarycodes = this.gensalarys();
    let locations = this.genlocationsearchoptions(salarycodes);
    let disciplines = this.gendisciplineoptions(salarycodes);
    console.log(locations);
    let newcode = {
      code: salarycodes.length + 2,
      payrate: 160,
      description: '',
      location: ''
    };
    return (
      <div className="SalaryCodes">
        <Grid>
          <Grid.Row>
            <Grid.Column width={5}>
              <Label>Search by Location</Label>
              <Dropdown
                placeholder="Location"
                fluid
                search
                selection
                options={locations}
                onChange={(e, { value }) => {
                  this.setState({ locationfilter: value });
                }}
              />
            </Grid.Column>
            <Grid.Column width={2}>
              <Button
                color="blue"
                id="deletecontactbutton"
                onClick={() =>
                  this.setState({
                    newcode: true,
                    showModal: true,
                    editvalue: newcode
                  })
                }
              >
                <Icon name="plus" /> Salary Code
              </Button>
            </Grid.Column>
            <Grid.Column width={6}>
              <Label>Search by Discipline</Label>
              <Dropdown
                placeholder="Discipline"
                fluid
                search
                selection
                options={disciplines}
                onChange={(e, { value }) => {
                  console.log(value);
                  this.setState({ disciplinefilter: value });
                }}
              />
            </Grid.Column>
            <Grid.Column width={1} />
          </Grid.Row>
          <Grid.Row>
            <Table selectable>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>Discipline</Table.HeaderCell>
                  <Table.HeaderCell>Location</Table.HeaderCell>
                  <Table.HeaderCell>Pay Rate</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              {this.genresults(salarycodes)}
            </Table>
          </Grid.Row>
        </Grid>
        <Divider />

        {this.gensalarymodal(this.state.editvalue)}
      </div>
    );
  }
}
export default SalaryCodes;



// WEBPACK FOOTER //
// ./src/components/hr/salaries.jsx